import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { ProductHotspotResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post } from "./common";

export const productHotspot = {
    record(data: typeof Requests.ProductHotspot.Record.Input) {
        return post<typeof data, ProductHotspotResponseTypes.Record>(
            `/product-hotspot/record`,
            data,
        );
    },
    create(data: typeof Requests.ProductHotspot.Create.Input) {
        return post<typeof data>(`/product-hotspot/create`, data);
    },
    obtain(id: string) {
        return get<ProductHotspotResponseTypes.Obtain>(`/product-hotspot/obtain/${id}`);
    },
    resellers(id: string) {
        return get<ProductHotspotResponseTypes.Resellers>(`/product-hotspot/resellers/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<ProductHotspotResponseTypes.Select>(
                `/product-hotspot/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        usable: (async (param?: SelectParam) => {
            const req = get<ProductHotspotResponseTypes.Usable>(
                `/product-hotspot/usable` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.ProductHotspot.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/product-hotspot/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
